import React, { FC } from "react";
import * as Yup from "yup";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { UserService } from "../../../services/user";
import { useForm, InputWraper, Button, CreateAlert } from "../../../modules";
import { InputText, InputPassword } from "../../../components";
import { AuthWraper } from "../authWraper";

export const PageAuthLogin: FC = () => {
  // const { executeRecaptcha } = useGoogleReCaptcha() as any;

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: [
      {
        name: "email",
        placeholder: "Tên đăng nhập",
        validate: Yup.string()
          .required("Vui lòng nhập tên đăng nhập!")
          .matches(/^.{6,50}$/, "Tên đăng nhập phải từ 6 đến 50 ký tự"),
      },
      {
        name: "password",
        placeholder: "Mật khẩu",
        validate: Yup.string()
          .required("Vui lòng nhập mật khẩu!")
          .matches(/^.{8,50}$/, "Mật khẩu phải từ 8 đến 50 ký tự"),
      },
    ],
    onSubmit: async (values) => {
      // let captcha = recaptcha;

      // try {
      //     if (!recaptcha) captcha = await executeRecaptcha('login');
      // } catch (error) {
      //     console.log(error);
      // }

      return UserService.login(values.email, values.password)
        .then(() => {
          CreateAlert({ message: "Đăng nhập thành công!", type: "success" });
        })
        .catch((err) => {
          // setRecaptcha('');
          const errorMessages = {
            EMAIL_DOES_NOT_EXIST: "Tên đăng nhập, mật khẩu không đúng!",
            INVALID_PASSWORD: "Tên đăng nhập, mật khẩu không đúng!",
            DISABLED_USER: "Tài khoản đã bị khóa!",
          };
          const alertMessage =
            errorMessages[err.message as keyof typeof errorMessages] ||
            err.message;
          CreateAlert({
            message: alertMessage,
            type: "danger",
          });

          throw err;
        });
    },
  });

  return (
    <AuthWraper>
      <div className="PageAuth login">
        <img src="/assets/images/maps.png" className="background" alt="" />

        <form onSubmit={handleSubmit}>
          <div className="head">
            <img className="logo" src="/assets/images/logo-vtech.png" alt="" />
            {/* <div className="title">
                            {translate('login-to-your-account')}
                        </div> */}
          </div>

          {/* <GoogleReCaptcha onVerify={token => setRecaptcha(token)} /> */}

          <InputWraper
            inputProps={getInputProps("email")}
            component={InputText}
          />

          <InputWraper
            inputProps={getInputProps("password")}
            component={InputPassword}
          />

          <Button
            className="btn-login"
            label={"Đăng nhập"}
            type="submit"
            isLoading={isSubmitting}
          />
        </form>
      </div>
    </AuthWraper>
  );
};
